/*!
* @name: jquery-izoomify
* @version: 2.7
*/

(function ($) {

    var defaults = {
        callback: false,
        target: false,
        duration: 120,
        magnify: 1.5,
        maxMagnify: 3,
        touch: true
    };

    var isTouchDevice = ('ontouchstart' in window) || navigator.maxTouchPoints > 0;

    function getDistance(t1, t2) {
        var dx = t1.clientX - t2.clientX;
        var dy = t1.clientY - t2.clientY;
        return Math.sqrt(dx * dx + dy * dy);
    }

    function getMidPoint(t1, t2, offset) {
        return {
            x: ((t1.clientX + t2.clientX) / 2) - offset.left,
            y: ((t1.clientY + t2.clientY) / 2) - offset.top
        };
    }

    function getPoint(t, offset) {
        return {
            x: t.clientX - offset.left,
            y: t.clientY - offset.top
        };
    }

    var _izoomify = function (target, duration) {

        var $target = $(target);
        var $img = $target.find('img:first');

        $target.css({
            position: 'relative',
            overflow: 'hidden'
        });

        $img.css({
            transform: 'translate3d(0,0,0) scale(1)',
            transformOrigin: '0 0',
            willChange: 'transform',
            backfaceVisibility: 'hidden',
            WebkitBackfaceVisibility: 'hidden',
            transition: 'transform ' + duration + 'ms ease'
        });

        return {
            apply: function (scale, x, y, noTransition) {
                if (noTransition) {
                    $img.css('transition', 'none');
                }
                $img.css({
                    transform:
                        'translate3d(' + x + 'px,' + y + 'px,0) scale(' + scale + ')'
                });
            },
            restoreTransition: function () {
                $img.css('transition', 'transform ' + duration + 'ms ease');
            },
            reset: function () {
                $img.css({
                    transition: 'transform ' + duration + 'ms ease',
                    transform: 'translate3d(0,0,0) scale(1)'
                });
            }
        };
    };

    $.fn.izoomify = function (options) {

        return this.each(function () {

            var $src = $(this);

            if ($src.data('izoomify-init')) {
                $src.trigger('izoomify.destroy');
            }

            var settings = $.extend({}, defaults, options || {});
            var target = settings.target || this;
            var $target = $(target);

            var api = _izoomify(target, settings.duration);
            $src.data('izoomify-init', true);

            /* ================= DESKTOP ================= */
            if (!isTouchDevice) {

                $src.on('mousemove.izoomify mouseover.izoomify', function (e) {
                    var o = $target.offset();
                    var x = e.pageX - o.left;
                    var y = e.pageY - o.top;

                    $target.find('img:first').css({
                        transformOrigin: x + 'px ' + y + 'px',
                        transform: 'scale(' + settings.magnify + ')'
                    });
                });

                $src.on('mouseleave.izoomify mouseout.izoomify', function () {
                    api.reset();
                });
            }

            /* ================= MOBILE ================= */
            if (settings.touch && isTouchDevice) {

                var zoomActive = false;
                var lastTap = 0;
                var DOUBLE_TAP_DELAY = 300;
                var suppressTap = false;

                var currentX = 0;
                var currentY = 0;
                var currentScale = 1;

                /* ANDROID SAFE PINCH BASELINE */
                var pinchStartScale = 1;
                var pinchStartX = 0;
                var pinchStartY = 0;
                var pinchStartDistance = 0;
                var pinchMid = { x: 0, y: 0 };
                var isPinching = false;

                var startX = 0;
                var startY = 0;

                function fullReset() {
                    zoomActive = false;
                    isPinching = false;
                    currentScale = 1;
                    currentX = 0;
                    currentY = 0;
                    api.reset();
                }

                /* ---- TOUCH START ---- */
                $src.on('touchstart.izoomify', function (e) {

                    /* PINCH START */
                    if (e.touches.length === 2) {
                        isPinching = true;
                        zoomActive = true;
                        suppressTap = true;
                        lastTap = 0;

                        pinchStartDistance = getDistance(e.touches[0], e.touches[1]);
                        pinchMid = getMidPoint(
                            e.touches[0],
                            e.touches[1],
                            $target.offset()
                        );

                        pinchStartScale = currentScale;
                        pinchStartX = currentX;
                        pinchStartY = currentY;

                        api.apply(currentScale, currentX, currentY, true);
                        return;
                    }

                    if (suppressTap) return;

                    /* DOUBLE TAP */
                    var now = Date.now();
                    var gap = now - lastTap;
                    lastTap = now;

                    if (gap > DOUBLE_TAP_DELAY) return;

                    e.preventDefault();

                    var tapPoint = getPoint(e.touches[0], $target.offset());

                    if (!zoomActive) {
                        zoomActive = true;
                        currentScale = settings.magnify;

                        currentX = tapPoint.x - currentScale * tapPoint.x;
                        currentY = tapPoint.y - currentScale * tapPoint.y;

                        api.apply(currentScale, currentX, currentY);
                    } else {
                        fullReset();
                    }
                });

                /* ---- DRAG START ---- */
                $src.on('touchstart.izoomify.drag', function (e) {
                    if (!zoomActive || isPinching || e.touches.length !== 1) return;
                    startX = e.touches[0].clientX;
                    startY = e.touches[0].clientY;
                    api.apply(currentScale, currentX, currentY, true);
                });

                /* ---- MOVE ---- */
                $src.on('touchmove.izoomify', function (e) {

                    /* PINCH MOVE */
                    if (isPinching && e.touches.length === 2) {
                        e.preventDefault();

                        var newDistance = getDistance(e.touches[0], e.touches[1]);
                        var factor = newDistance / pinchStartDistance;
                        var newScale = pinchStartScale * factor;

                        if (newScale <= 1) {
                            fullReset();
                            return;
                        }

                        newScale = Math.min(settings.maxMagnify, newScale);

                        currentX =
                            pinchMid.x -
                            (newScale / pinchStartScale) *
                                (pinchMid.x - pinchStartX);

                        currentY =
                            pinchMid.y -
                            (newScale / pinchStartScale) *
                                (pinchMid.y - pinchStartY);

                        currentScale = newScale;

                        api.apply(currentScale, currentX, currentY, true);
                        return;
                    }

                    /* DRAG MOVE */
                    if (!zoomActive || isPinching || e.touches.length !== 1) return;

                    e.preventDefault();

                    var touch = e.touches[0];
                    var dx = touch.clientX - startX;
                    var dy = touch.clientY - startY;

                    api.apply(currentScale, currentX + dx, currentY + dy, true);
                });

                /* ---- TOUCH END (ANDROID FIX) ---- */
                $src.on('touchend.izoomify', function (e) {

                    api.restoreTransition();

                    /* PINCH → DRAG HANDOFF FIX */
                    if (isPinching) {
                        isPinching = false;
                        suppressTap = false;

                        if (e.touches.length === 1) {
                            startX = e.touches[0].clientX;
                            startY = e.touches[0].clientY;
                        }
                        return;
                    }

                    if (!zoomActive) return;

                    if (e.changedTouches.length === 1) {
                        currentX += e.changedTouches[0].clientX - startX;
                        currentY += e.changedTouches[0].clientY - startY;
                    }
                });
            }

            /* ================= DESTROY ================= */
            $src.one('izoomify.destroy', function () {
                $src.off('.izoomify');
                api.reset();
                $src.removeData('izoomify-init');
            });

            if ($.isFunction(settings.callback)) {
                settings.callback.call($src);
            }
        });
    };

    $.fn.izoomify.defaults = defaults;

})(window.jQuery);
